// extracted by mini-css-extract-plugin
export default {"formWrap":"ProfileDocumentsForm_formWrap--qLo","fieldWrap":"ProfileDocumentsForm_fieldWrap--eeE","saveBtn":"ProfileDocumentsForm_saveBtn--xsk"};